import React, {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import {v4} from 'uuid';
import ToastMessage from './StyledToastMessage';
import {setFormV2ToasterVisibility} from '../../../actions/toastactions';
import {clearErrors} from '../../../actions/erroractions';

export default function ToastMessageContainer(props) {
	const {className, toastClassName, toastFeature} = props;

	const dispatch = useDispatch();

	const toastMessageDetails = useSelector((state) => state.toasterDetails);

	const {showToaster, toasterVariant, toasterDescription, feature, timeout} = toastMessageDetails;

	// toastFeature matches the feature in state (show only in matching container)
	const shouldShowToast = showToaster && (!feature || toastFeature === feature);

	const handleOnClose = useCallback(() => {
		dispatch(setFormV2ToasterVisibility(false));
		dispatch(clearErrors());
	}, [dispatch]);

	useEffect(() => {
		if (timeout > 0) {
			const timer = setTimeout(() => {
				dispatch(setFormV2ToasterVisibility(false));
				dispatch(clearErrors());
			}, timeout);

			// Cleanup the timer if the component unmounts or timeout changes
			return () => clearTimeout(timer);
		}
	}, [timeout, dispatch]);

	return (
		<StyledToastMessageContainer className={`StyledToastMessageContainer ${className ? className : ''}`}>
			{shouldShowToast && (
				<ToastMessage key={v4()} className={`StyledToastMessage${toastClassName ? ' ' + toastClassName : ''}`} variant={toasterVariant} onClose={handleOnClose}>
					{toasterDescription}
				</ToastMessage>
			)}
		</StyledToastMessageContainer>
	);
}

const StyledToastMessageContainer = styled.section`
	position: absolute;
	z-index: 1;
	width: calc(100% - var(--px-100));
	margin: var(--px-24) var(--px-60) 0 var(--px-40);
	top: var(--px-56);
	&.modal-messages-container {
		margin: 0 !important;
	}
	&.ModalErrorToastMessageContainer {
		/* Specific styles for Modal Error Toast Messages */
		top: var(--px-5) !important;
		margin: 0 !important;
		width: calc(100% - var(--spacing-x-large) - var(--spacing-x-large)) !important;
	}
	&.ErrorSummaryToastMessageContainer {
		/* Specific styles for Error Summary Toast Messages */
	}
	&.APPToastMessageContainer {
		/* Specific styles for APP Toast Messages */
	}
`;
